import { io } from "socket.io-client";

export const SOCKET_PATH = "/api/socket.io";

export const createChatSocket = () =>
  io(process.env.REACT_APP_BACKEND_URL, { path: SOCKET_PATH });
